// extracted by mini-css-extract-plugin
module.exports = {"item":"reviews_item__CpCmf"};